<template>
  <el-breadcrumb
    v-if="breadcrumbList && breadcrumbList.length"
    separator="/"
  >
    <el-breadcrumb-item
      v-for="(item, index) in breadcrumbList"
      :key="item.path"
    >
      <span
        v-if="item.redirect === 'noRedirect' || index == breadcrumbList.length - 1"
      >
        {{ item.meta.title }}
      </span>
      <a
        v-else
        @click.prevent="linkHandle(item)"
      >
        {{ item.meta.title }}
      </a>
    </el-breadcrumb-item>
  </el-breadcrumb>
</template>

<script lang="ts">
  import { useStore } from 'vuex';
  import {
    defineComponent, reactive, toRefs, watch, computed,
  } from 'vue';
  import { useRoute, useRouter } from 'vue-router';

  interface InterfaceState {
    breadcrumbList: any
  }

  export default defineComponent({
    name: 'breadcrumb',
    setup() {
      const route = useRoute();
      const router = useRouter();
      const { getters } = useStore();

      const state: InterfaceState = reactive({
        breadcrumbList: [],
      });

      const layout = computed(() => getters.layout);

      function getBreadcrumbList() {
        // only show routes with meta.title
        const matched: any = route?.matched?.filter((item) => item.meta && item.meta.title) || [];
        console.log('matched---',matched)
        // 如果有自定义的面包屑，使用自定义的面包屑，否则使用自动生成的
        const breadcrumbs = route?.meta?.breadcrumbs;
        if (breadcrumbs) {
          state.breadcrumbList = breadcrumbs || [];
        } else {
          state.breadcrumbList = matched.filter((item: any) => {
            if (item.meta) {
              return item.meta.title && !item.meta.hideBreadcrumb;
            }
            return false;
          });
          console.log('state.breadcrumbList---',state.breadcrumbList)
        }
      }

      watch(route, (val) => {
        if (val && !val.path.startsWith('/redirect/')) {
          getBreadcrumbList();
        }
      }, {
        immediate: true,
      });

      return {
        ...toRefs(state),
        layout,
        linkHandle: (val: any) => {
          const { redirect, path, query } = val;
          if (redirect) {
            router.push(redirect);
            return;
          }
          router.push({
            path,
            query,
          });
        },
      };
    },
  });
</script>
